import {getObject, postObjectWithApiError, getJson, IResultAndError} from '../../lib/ChoiceApi'; 
import {IRefundReturnRequest,ITransferReturnRequest,IBillingResponse,IRefundReassignment,IClaimProcedureIds,IClaimProcedure,IClaimPayment,IClaimHeader,IClaimComment,IClaimEntityRefunds} from '../../lib/Models/ClaimModel'; 
import {IAddRemarkCodeInputs, IEobRemarkCodes, IDeleteRemarkCodeInput} from '../../lib/Models/RemarkCodesModel';
import { ICompanySetting } from '../Models/CompanySettingModel';
export enum ErrorReturnMessage {
    claimHeader = "Unable to obtain claim header details",
    procedureList = "Unable to obtain procedure listing",
    procedure = "Unable to obtain procedure details",
    payments = "Unable to obtain procedure payments",
    claimComments = "Unable to obtain claim comments",
    procedureComments = "Unable to obtain procedure comments",
    refunds = "Unable to obtain claim refunds",
    reassignment = "Unable to re-assign refunds.",
    refundReturn = "Unable to build refund returns.",
    transferReturn = "Unable to build tranfer returns."
};

export async function getClaimHeader(claimID : number): Promise<IResultAndError<IClaimHeader>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimHeader/${claimID}`;
    const responseObject = await getObject<IClaimHeader>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.claimHeader;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimProcedureList(claimID : number): Promise<IResultAndError<IClaimProcedureIds[]>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimProcedureList/${claimID}`;
    const responseObject = await getObject<IClaimProcedureIds[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.procedureList;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimProcedures(claimID : number): Promise<IResultAndError<IClaimProcedure[]>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimProcedures/${claimID}`;
    const responseObject = await getObject<IClaimProcedure[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.procedure;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimProcedure(claimID : number, diagnosisID : number): Promise<IResultAndError<IClaimProcedure>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimProcedure/${claimID}/${diagnosisID}`;
    const responseObject = await getObject<IClaimProcedure>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.procedure;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimPayments(claimID : number, diagnosisID : number): Promise<IResultAndError<IClaimPayment[]>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimPayments/${claimID}/${diagnosisID}`;
    const responseObject = await getObject<IClaimPayment[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.payments;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimComments(claimID : number): Promise<IResultAndError<IClaimComment[]>>{  
    let returnErrorMessage = ""; 
    const url = `api/Billing/Claim/GetClaimComments/${claimID}`;
    const responseObject = await getObject<IClaimComment[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.claimComments;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimProcedureComments(claimID : number, diagnosisID : number): Promise<IResultAndError<IClaimComment[]>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimProcedureComments/${claimID}/${diagnosisID}`;
    const responseObject = await getObject<IClaimComment[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.procedureComments;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function getClaimEntityRefunds(claimID : number): Promise<IResultAndError<IClaimEntityRefunds[]>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/Claim/GetClaimEntityRefunds/${claimID}`;
    const responseObject = await getObject<IClaimEntityRefunds[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.refunds;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
};
export async function setRefundReassignment(payload: IRefundReassignment): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/Claim/SetRefundReassignment", payload);
};
// TODO: Refactor int companysettings.ts or use store.
export async function getCompanySetting(parameterName: string, parameterOrder: number): Promise<string> {
    const result = await getObject<ICompanySetting>(`api/CompanySetting/Get/${parameterName}/${parameterOrder}`); 
    if (!result) {
        return "";
    } 
    if ("parameterValue" in result) {
        return ("" + result.parameterValue);
    }
    return "";
};
export async function getCompanySettingNumber(parameterName: string, parameterOrder: number, defaultValue: number = 0): Promise<number> {
	const result = await getCompanySetting(parameterName, parameterOrder);
    
	if (undefined === result) {
        return defaultValue;
    } 
	return isNaN(+result) ? defaultValue : +result;
};
export async function refundReturn(payload: IRefundReturnRequest): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/Claim/RefundReturn", payload);
};
export async function transferReturn(payload: ITransferReturnRequest): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/Claim/TransferReturn", payload);
};
export async function getEobRemarksById(detailId2 : number): Promise<IEobRemarkCodes[] | undefined>{  
    return await getObject(`api/Billing/Claim/GetEobRemarkCodes/${detailId2}`);  
};
export async function addRemarkCodes(payload: IAddRemarkCodeInputs): Promise<IResultAndError<IBillingResponse>>{
    return await postObjectWithApiError("api/Billing/Claim/AddRemarkCodes", payload);  
};
export async function deleteRemarkCode(payload: IDeleteRemarkCodeInput): Promise<IResultAndError<IBillingResponse>>{
    return await postObjectWithApiError("api/Billing/Claim/DeleteRemarkCodes", payload);  
};
